import { render } from "./SurveyForm.vue?vue&type=template&id=a824d9fa"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__